const productClickAnalyticsMapper = require('../gtmmapper/productclick-analytics-mapper');

class ShelfProductTagImageController {
    constructor(shelfProductService, gtmService) {
        this.shelfProductService = shelfProductService;
        this.gtmService = gtmService;
    }

    tagClick(event) {
        // addToTrolley or addMultipleToTrolley are not links anymore
        // they prevent the link to follow href
        if (this.shelfProductService.processTrolleyProductTagLink(this.product.ImageTag.TagLink)) {
            event.preventDefault();
        }

        this.gtmService.push(this.product, productClickAnalyticsMapper);
    }

    gtmStaticTagClickPush() {
        this.gtmService.push({ event: 'staticTagImageClick' });
    }
}

const shelfProductTagImageComponentDefinition = {
    bindings: {
        product: '<',
    },
    controller: ['ShelfProductService', 'GtmService', ShelfProductTagImageController],
    template: require('./shelf-product-tag-image.component.html').trim(),
};

module.exports = {
    ShelfProductTagImageController,
    shelfProductTagImageComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/shelf-product-tag/shelf-product-tag-image.component.js